import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { IExpertQuestionPrice } from '@techspert-io/experts';
import moment from 'moment';

export interface IAskExpertFollowUpQuestionsDialogData {
  defaultSelectedExpertIds: string[];
  expertOptions: { expertId: string; expertName: string }[];
  prices: IExpertQuestionPrice[];
}

export interface IAskExpertFollowUpQuestionsDialogResult {
  expertIds: string[];
  question: string;
  priceId: string;
  deadline?: string;
}

@Component({
  selector: 'app-ask-expert-followup-questions-dialog',
  templateUrl: './ask-expert-followup-questions-dialog.component.html',
  styles: [
    `
      h3 {
        margin-bottom: 0;
        margin-top: 0;
      }
    `,
  ],
  standalone: false,
})
export class AskExpertFollowUpQuestionsDialogComponent implements OnInit {
  minDate = this.getMinDate();

  submissionForm = new FormGroup({
    expertIds: new FormControl<string[]>(
      [],
      [Validators.required, Validators.minLength(1)]
    ),
    question: new FormControl<string>(null, Validators.required),
    priceId: new FormControl<string>(null, [Validators.required]),
    deadline: new FormControl<string>(null, []),
  });

  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: IAskExpertFollowUpQuestionsDialogData,
    private dialogRef: MatDialogRef<
      AskExpertFollowUpQuestionsDialogComponent,
      IAskExpertFollowUpQuestionsDialogResult
    >
  ) {}

  get pricingOptions() {
    return this.data.prices.map(
      ({
        expected_minutes,
        unit_price,
        expert_follow_up_question_price_id,
      }) => ({
        label: `Up to ${expected_minutes} minute${expected_minutes === 1 ? '' : 's'} (${unit_price} unit${unit_price === 1 ? '' : 's'})`,
        priceId: expert_follow_up_question_price_id,
      })
    );
  }

  ngOnInit() {
    if (this.data.defaultSelectedExpertIds.length) {
      this.submissionForm.controls.expertIds.setValue(
        this.data.defaultSelectedExpertIds,
        { emitEvent: false }
      );
    }
  }

  submit() {
    this.submissionForm.markAllAsTouched();

    if (this.submissionForm.valid) {
      this.dialogRef.close({
        expertIds: this.submissionForm.value.expertIds,
        question: this.submissionForm.value.question,
        priceId: this.submissionForm.value.priceId,
        deadline: this.submissionForm.value.deadline,
      });
    }
  }

  private getMinDate() {
    return moment().format('YYYY-MM-DD');
  }
}
